export default __webpack_public_path__ + "static/media/exp_I.b2fcd029.png";